module.exports = __webpack_public_path__ + "img/402.services.617357a2.svg";